import React from 'react';
import PropTypes from 'prop-types';
import { Cookies } from 'react-cookie';
import { Dialog, IconButton, Paper, Subheader } from 'material-ui';
import { white } from 'material-ui/styles/colors';
import styles from './PageInfo.css';
import QRCodeIcon from '../icon/QRCodeIcon';
import Info from '../common/Info/Info';
import style from '../../styles/styles';
import withTranslation from '../../hoc/withTranslation';
import APIService from '../../services/api';
import ModuleService from '../../services/module';

const cookies = new Cookies();
const Timestamp = require('react-timestamp');

class PageInfo extends React.Component {
    static propTypes = {
        page: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        lang: PropTypes.string,
    };

    state = {
        img: null,
    };

    static defaultProps = {
        lang: 'fr',
    };

    onClose = () => {
        this.setState({ img: null });
    };

    getQrCode = async () => {
        const img = await APIService.getDynamicLinkQrCode(this.props.app.id,
            'pages',
            this.props.page.id,
            'png',
            cookies.get('token'),
            this.props.lang,
        );
        this.setState({ img: window.webkitURL.createObjectURL(img) });
    };

    render() {
        const page = this.props.page;
        return (
            <Paper>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('generic.information')}
                    {ModuleService.hasModule(this.props.app, ModuleService.DYNAMIC_LINK)
                        && <IconButton
                            style={styles.rightVisibleIcon}
                            tooltipPosition="bottom-left"
                            onClick={this.getQrCode}
                        >
                            <QRCodeIcon color={white} />
                        </IconButton>
                    }
                </Subheader>

                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={page.id}
                    />
                    {page.title &&
                        <Info
                            title={this.props.t('generic.title')}
                            content={page.title}
                        />
                    }
                    {page.content &&
                        <Info
                            title={this.props.t('generic.content')}
                            content={page.content}
                            html={true}
                        />
                    }
                    {page.tag &&
                        <Info
                            title={this.props.t('generic.tag')}
                            content={page.tag}
                        />
                    }
                    <Info
                        title={this.props.t('generic.display_order')}
                        content={page.display_order}
                    />
                    <Info
                        title={this.props.t('generic.created_at')}
                        content={<Timestamp time={page.created_at} format="full" twentyFourHour />}
                    />
                    <Info
                        title={this.props.t('generic.updated_at')}
                        content={(
                            page.updated_at &&
                            <Timestamp time={page.updated_at} format="full" twentyFourHour />
                        ) || this.props.t('generic.updated_never')}
                        divider={false}
                    />
                </div>
                <Dialog
                    open={this.state.img !== null}
                    onRequestClose={this.onClose}
                    modal={false}
                    contentStyle={styles.modal}
                    autoDetectWindowHeight={true}
                >
                    <img src={this.state.img} alt={'Erreur lors de la génération de l\'image'} />
                </Dialog>
            </Paper>
        );
    }
}

export default withTranslation(PageInfo);



// WEBPACK FOOTER //
// src/components/page/PageInfo.js